export const BRAND_DAY_SLUG = 'brand-day'
